class CollectionBlock extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.js-featured-collection-swiper')
    const nextEl = this.parentElement.querySelector(`.featured-collection--icon-next`)
    const prevEl = this.parentElement.querySelector(`.featured-collection--icon-previous`)
    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: 2.2,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 15,
      slidesOffsetBefore: 15,
      slidesPerGroup: 2,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        1024: {
          slidesPerView: 1.9,
          spaceBetween: 10,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          slidesPerGroup: 1,
        },
        1600: {
          slidesPerView: 2.5,
          spaceBetween: 10,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          slidesPerGroup: 2,
        },
      },
    }

    this.$swiper = new Swiper(swiperEl, option)
    this.$swiper.on('slideChangeTransitionEnd', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.on('afterInit', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.on('resize', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.on('fromEdge', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.on('toEdge', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.init()
  }

  disconnectedCallback() {
    if (this.$swiper && typeof this.$swiper.destroy === 'function') {
      this.$swiper.destroy(true, true)
    }
  }

  onRenderSlidesIndexes(swiper) {
    const activeIndexEl = this.parentElement.querySelector(`.js-featured-collection-carousel-index`)
    const totalGroupsEl = this.parentElement.querySelector(`.js-featured-collection-carousel-pages`)
    let currentGroupIndex = swiper.realIndex + 1
    if (swiper.params.slidesPerGroup > 1) {
      currentGroupIndex = Math.ceil(((swiper.realIndex - 1) + swiper.params.slidesPerGroup) / swiper.params.slidesPerGroup)
    }
    const totalSlides = swiper.slides.length
    const totalGroups = Math.ceil(totalSlides / swiper.params.slidesPerGroup)
    activeIndexEl.innerHTML = swiper.isEnd ? totalGroups: currentGroupIndex
    totalGroupsEl.innerHTML = totalGroups
  }
}

customElements.define('collection-block', CollectionBlock)
